import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../shared/context/auth-context';
import moment from 'moment';
import CardList from '../components/CardList';
import DatePicker from "react-datepicker";
import Modal from '../../shared/components/UIElements/Modal';
import Scroll from '../../shared/components/navigation/Scroll';
import Button from '../../shared/components/formElements/Button';
import Input from '../../shared/components/formElements/Input';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useHttpClient } from "../../shared/hooks/http-hook";
import { useForm } from '../../shared/hooks/form-hook';
import { VALIDATOR_REQUIRE} from '../../shared/util/validators';
import { Box } from "@material-ui/core";
import { formatPhoneNumber } from "../../print/page/Print";
import { useCustomers } from '../../shared/hooks/customers-hook';
import { useWindow } from '../../shared/hooks/window-hook';
import "react-datepicker/dist/react-datepicker.css";
import './Appointments.css';
import Capitalize from "../../shared/components/UIElements/Capitalize ";

export const getMoment = (date) => {
  let day = date.getDate();
  let month = date.getMonth()+1;
  let year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export const convertDate = (date) => {
  const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  let weekDay = weekday[date.getDay()];
  let year = date.getFullYear();
  let month = monthNames[date.getMonth()];
  let day = date.getDate();
  return `${weekDay}, ${month} ${day}, ${year}`;
}

const  Appointment = () => {

  const { suggestedCustomers } = useCustomers();
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const history = useHistory();

  const paramDate = useParams().date;


  //today's appointment states
  const [time, setTime] = useState("");
  const [customer, setCustomer] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [id, setId] = useState("");
  const [done, setDone] = useState(false);

  //other states

  const [pickedDate, setPickedDate] = useState(moment(paramDate.split('T')[0]).toDate());

  const [selectedLabel, setSelectedLabel] = useState("Custom");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loadedAppointment, setLoadedAppointment] = useState([]);

  //explicit state update
  const [forceUpdate, setForceUpdate] = useState("true");
  const forceStateUpdate = () => {
    forceUpdate ? setForceUpdate(false) : setForceUpdate(true);
  }

  // custom hook destructuring
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      customer: {
        value: '',
        isValid: false
      },
      phone: {
        value: '',
        isValid: false
      },
      description: {
        value: '',
        isValid: false
      },
    },
    false
  );

  useEffect(() => {
    
    const requestOptions = {
      method: 'GET',
      headers: { 
        Authorization: 'Bearer '+ auth.token
      },
      body: null
    };
    //send a get request for existing appointment
    fetch(process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`, requestOptions)
      .then( async response =>{
        const data = await response.json();
        if (response.ok) {
          setLoadedAppointment(data.appointments);
        } else  {
          //if appointment does not exist, send a post request to create one
          const requestOptions = {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              Authorization: 'Bearer '+ auth.token
            },
            body: JSON.stringify({ date: paramDate })
          };
          //now that appointment has created we can send a get request
          fetch(process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`, requestOptions)
          .then(async response => {
              if (response.ok) {
                const requestOptions = {
                  method: 'GET',
                  headers: { 
                    Authorization: 'Bearer '+ auth.token
                  },
                  body: null
                };
                fetch(process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`, requestOptions)
                .then(async response =>{
                  const data = await response.json();
                  if (response.ok) {
                    setLoadedAppointment(data.appointments);
                  } else  {
                    throw new Error("Cannot fetch appointment", 401);
                  }
                  return response;
                })
              } else {
                throw new Error("Appointment does not exist", 401);
              }
              return response;
          })
        }          
      })
  }, [paramDate, forceUpdate, auth.token]);



  const updateAppointmentStateHandler = (id, time, customer, type, description, phone, done ) => {
    setShowConfirmModal(true);
    setTime(time);
    setCustomer(customer);
    setType(type);
    setId(id);
    setPhone(phone);
    setDescription(description)
    setDone(done);
  };

  const cancelHandler = () => {
    setShowConfirmModal(false);
  };

  const scheduleAppointmentHandler = async () => {
    try {
      setShowConfirmModal(false);
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`,
        'POST',
        JSON.stringify({
          date: paramDate,
          id,
          type: selectedLabel,
          customer: Capitalize(formState.inputs.customer.value),
          phone: formState.inputs.phone.value,
          description: Capitalize(formState.inputs.description.value)
        }),
        { 
          'Content-Type': 'application/json',
           Authorization: 'Bearer '+ auth.token
        }
      );
      forceStateUpdate();
      setSelectedLabel("Custom");
    } catch (err) {}
  }

  const deleteAppointmentHandler = async () => {
    try {
      setShowConfirmModal(false);
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`,
        'DELETE',
        JSON.stringify({
          date: paramDate,
          id
        }),
        { 
          'Content-Type': 'application/json',
          Authorization: 'Bearer '+ auth.token
        }
      );
      forceStateUpdate();
    } catch (err) {}
  }


  const DayNavigatorHandler = (n)=>{
    let dt = new Date(pickedDate);
    dt.setDate(pickedDate.getDate() + n);
    setPickedDate(dt)
  }

  const updateLabelHandler = (event) => {
    setSelectedLabel(event.target.value);
  }

  const resetDateHandler = () => {
    setPickedDate(new Date());
  }

  useEffect(() => {
    history.push(`/appointments/${(moment(pickedDate).format('YYYY-MM-DD[T00:00:00.000Z]'))}`);
  }, [pickedDate, history]);


  const updateHandler = async event => {
    event.preventDefault();
    setShowConfirmModal(false);
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/appointments/${paramDate}/edit`,
        'PATCH',
        JSON.stringify({
          description: formState.inputs.description.value,
          date: paramDate,
          id
        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer '+ auth.token
        }
      );
      history.push(`/appointments/${paramDate}`);
      forceStateUpdate();
    } catch (err) {}
  };

  const phoneFound = suggestedCustomers.find(customer => customer.name === formState.inputs.customer.value );
  if (phoneFound) {
    formState.inputs.phone.value = String(phoneFound.phone);
    formState.inputs.phone.isValid = true;
  }
  
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

      <div className='tc '>
        <div>
          <div>
            <Button inverse simple to={`/appointments/${(moment(pickedDate).format('YYYY-MM-DD[T00:00:00.000Z]'))}/update`}>TABLE VIEW</Button>
          </div>

          <div >
            <Button simple to={`/appointments/search/${moment().format('YYYY-MM')}/${moment().add(1, 'months').format('YYYY-MM')}`}>
              SEARCH
            </Button>
          </div>
   
        </div>
        
        <div className='mb3' style={{ fontSize:"22px", fontWeight :"bold",
            textDecoration: "underline"}} >
            {convertDate(pickedDate)}
        </div>

        <div className='flex  justify-center content-center'>     
          <div className=" w-5 mr3">
            <button className="previous round grow" style={{height:"45px", width: "45px", fontSize:"20px"}}
              onClick={() => DayNavigatorHandler(-7)}
            >&laquo;</button>
          </div>
          <div className="w-5">
            <button className="previous round grow" style={{height:"45px", width: "45px", fontSize:"20px"}}
              onClick={() => DayNavigatorHandler(-1)}
            >&#8249;</button>
          </div>
          <div className={width > 800 ? " w-10 mr3 ml3" : " w-30 mr3 ml3"} >
            <DatePicker  selected={pickedDate} onChange={(date) => setPickedDate(date)} />
          </div>
          <div className=" w-5  mr3">
            <button className="next round grow" style={{height:"45px", width: "45px", fontSize:"20px"}}
              onClick={() => DayNavigatorHandler(1)}
            >&#8250;</button>
          </div>
          <div className=" w-5  mr1">
            <button className="next round grow" style={{height:"45px", width: "45px", fontSize:"20px"}}
              onClick={() => DayNavigatorHandler(7)}
            >&raquo;</button>
          </div>
        </div>

    
  


        <label onClick={resetDateHandler}>
          <div className="box-section">     
            <Box color="black" bgcolor="#AAAAAA" p={1}>
            Custom
            </Box>
            <Box color="black" bgcolor="#96CCFF" p={1}>
            First Fitting
            </Box>
            <Box color="black" bgcolor="#FBF1A9" p={1}>
            Second Fitting
            </Box>
            <Box color="black" bgcolor="#FF725C" p={1}>
            Third Fitting
            </Box>
            <Box color="black" bgcolor="#A463F2" p={1}>
            Pick Up
            </Box>
            <Box color="black" bgcolor="#FFA3D7" p={1}>
            Looking 
            </Box>
            <Box color="black" bgcolor="#9EEBCF" p={1}>
            Bridal Alterations 
            </Box>
          </div>
        </label>
      
        <Modal
          show={showConfirmModal}
          onCancel={cancelHandler}
          header={type? "Has Booked for " + customer + (done ? ' ✔':''):"Booking a new appointemnt"}
          footerclassName="customer-item__modal-actions"
          footer={
            type ? (
              <div className='tc'>
              <Button inverse onClick={cancelHandler}>
                CANCEL
              </Button>
              <Button success onClick={updateHandler}>
                  UPDATE
                </Button>
              <Button danger onClick={deleteAppointmentHandler}>
                Delete
              </Button>
            </div>
            ) : (
              <div className='tc'>
                <Button inverse onClick={cancelHandler}>
                  CANCEL
                </Button>
                <Button  disabled={!formState.isValid} onClick={scheduleAppointmentHandler}>
                  SCHEDULE
                </Button>
              </div>
            )
          }
        >
          {type ? (
             <React.Fragment>
              <div className={`pa2  shadow-2 ${type === "Custom" ? 'bg-light-silver': 
                              (type === "Pick Up" ? 'bg-light-purple':
                              (type === "First Fitting" ? 'bg-light-blue':
                              (type === "Second Fitting" ? 'bg-light-yellow':
                              (type === 'Third Fitting' ? 'bg-light-red':
                              (type === 'Looking' ? 'bg-light-pink':
                              (type === 'Bridal Alterations' ? 'shadow-5 bg-light-green':
                              'bg-light-green'))))))}  } `}>
              <div className="flex ">
              <div className=" w-50  mr2">
                <label htmlFor="name" className="f6 b db mb2">Type <span className="normal black-60"></span></label>
                <input disabled  id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={type}/>
              </div>
              <div className=" w-50  mr2">
                <label htmlFor="name" className="f6 b db mb2">Day <span className="normal black-60"></span></label>
                <input disabled id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={convertDate(pickedDate).split(",")}/>
              </div>
              </div>
              <div className="flex ">
              <div className=" w-50  mr2">
                <label htmlFor="name" className="f6 b db mb2">Date <span className="normal black-60"></span></label>
                <input disabled id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={getMoment(pickedDate)}/>
              </div>
                <div className=" w-50 mr2">
                <label htmlFor="name" className="f6 b db mb2">Time <span className="normal black-60"></span></label>
                <input disabled id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={time}/>
              </div>
              </div>
              <div className="flex ">
              <div className=" w-50 mr2">
                <label htmlFor="name" className="f6 b db mb2">Customer <span className="normal black-60"></span></label>
                <input disabled id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={customer}/>
              </div>
                <div className=" w-50  mr2">
                <label htmlFor="name" className="f6 b db mb2">Phone Number <span className="normal black-60"></span></label>
                <input disabled id="name" className="pa2 mb2 db w-100 border bg-white" type="text" readOnly value={formatPhoneNumber(phone)}/>
              </div>
              </div>
            
            <div className="flex ">
              <div className=" w-100 pa1 mr2">
              <label htmlFor="name" className="f6 b db mb2">Description <span className="normal black-60"></span></label>
                <Input 
                  id="description"
                  type="text"
                  // label="Description"
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText="Please enter a valid description"
                  onInput={inputHandler}
                  initialValue={description}
                  initialValid={true}
                />
              </div>
              </div>
               
              </div>
            </React.Fragment>    
            ) : (
              <React.Fragment>
                {convertDate(pickedDate) + " at " + time}
              <Input
                id="customer"
                element="smart_input"
                type="text"
                label="Customer Name"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="Please enter a name"
                onInput={inputHandler}
                suggestionArray={suggestedCustomers} 
             
              />
              { !phoneFound && <Input
                id="phone"
                element="input"
                type="phone"
                pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                label="Phone Number"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="Please enter a phone number"
                onInput={inputHandler}
              />}
              <Input
                id="description"
                type="text"
                label="Description"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="Please enter a valid description"
                onInput={inputHandler}
              />
              <label>
                Select Type
                <select 
                  style={{"marginLeft" : "10px"}} 
                  value={selectedLabel} 
                  onChange={updateLabelHandler}>
                  <option value="Custom">Custom</option>
                  <option value="First Fitting">First Fitting</option>
                  <option value="Second Fitting">Second Fitting</option>
                  <option value="Third Fitting">Third Fitting</option>
                  <option value="Pick Up">Pick Up</option>
                  <option value="Looking">Looking</option>
                  <option value="Bridal Alterations">Bridal Alterations</option>
                </select>
              </label>       
            </React.Fragment> 
          )}
        </Modal>

         <Scroll >
          {loadedAppointment.info &&
          <CardList schedule={loadedAppointment.info} onclick={updateAppointmentStateHandler}/>}
        </Scroll>

        {isLoading && <LoadingSpinner asOverlay />}
        
      </div>
    </React.Fragment>
  )
}

export default Appointment;
